import { Controller } from "@hotwired/stimulus"

// Shows how far the job worker has got with an import's images, checking every few seconds
export default class extends Controller {
  static targets = ["bar", "progress", "summary"]
  static values = { url: String, total: Number }

  connect() {
    this.poll()
    this.timer = setInterval(() => this.poll(), 4000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  async poll() {
    let status
    try {
      const response = await fetch(this.urlValue, { headers: { Accept: "application/json" }, credentials: "same-origin" })
      // Signed out (redirected to the sign-in page) or a server error: say so rather than freeze
      if (!response.ok || response.redirected) throw new Error(`status ${response.status}`)
      status = await response.json()
    } catch {
      this.summaryTarget.textContent = "Lost track of the images (they keep downloading). Reload the page to check again."
      return
    }

    const total = Math.max(this.totalValue, 1)
    const done = Math.min(total, Math.max(0, this.totalValue - status.queued))
    this.barTarget.style.width = `${(done / total) * 100}%`
    this.progressTarget.setAttribute("aria-valuenow", done)

    if (status.queued > 0) {
      this.summaryTarget.textContent = `Fetching images in the background: ${done} of ${this.totalValue} done. You can close this page.`
      return
    }

    clearInterval(this.timer)
    this.summaryTarget.textContent = status.missing > 0
      ? `Finished. ${status.missing} ${status.missing === 1 ? "listing has" : "listings have"} no image yet: “Fetch images” on the week page lists them.`
      : "Finished: every listing has its image."
  }
}
